<template>
  <div class="outerCtn">
    <div>
      <img src="../../../assets/news/banner.png" alt="" width='100%'/>
    </div>
    <div class="phone_title">{{news.title}}</div>
    <div v-html="news.content" class="phone_content"></div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      news: ''
    }
  },
  mounted(){
    let id = this.$route.params.id.split('.')[0]
    this.getNew(id|| '')
  },
  methods: {
    getNew(id){
      var params = new URLSearchParams();
      params.append('start', 1);
      params.append('limit', 1);
      params.append('aid', id);
      this.$axios.post('/api/websiteNews/websiteList',params).then(res=>{
        this.news = res.data.data.records[0]
      })
    },
  },
}
</script>

<style>
  .outerCtn{
    background-color:#23262A ;
    color: white;
    min-height: 100vh;
    padding: 0 10px;
    color: white !important;
  }
  .phone_title{
    font-weight: 600;
    padding: 20px;
    padding-bottom: 0;
    text-align: left;
    line-height: 24px;
    font-size: 22px;
  }
  .phone_content{
    text-align: left;
    color: white;
    padding: 18px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    
  }
  .phone_content p{
    line-height: 20px;
  }
  .phone_content img{
    width: 97%;
    height: auto;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/phone/phoneNewsDetail.vue